export default __webpack_public_path__ + "static/media/design-2.62f6ae4e.png";